// ShiftLate
export const FETCH_TIME_DEDUCTION_SHIFT_LATE_REQUEST = 'FETCH_TIME_DEDUCTION_SHIFT_LATE_REQUEST';
export const FETCH_TIME_DEDUCTION_SHIFT_LATE_SUCCESS = 'FETCH_TIME_DEDUCTION_SHIFT_LATE_SUCCESS';
export const FETCH_TIME_DEDUCTION_SHIFT_LATE_FAILURE = 'FETCH_TIME_DEDUCTION_SHIFT_LATE_FAILURE';

export const SAVE_TIME_DEDUCTION_SHIFT_LATE_REQUEST = 'SAVE_TIME_DEDUCTION_SHIFT_LATE_REQUEST';
export const SAVE_TIME_DEDUCTION_SHIFT_LATE_SUCCESS = 'SAVE_TIME_DEDUCTION_SHIFT_LATE_SUCCESS';
export const SAVE_TIME_DEDUCTION_SHIFT_LATE_FAILURE = 'SAVE_TIME_DEDUCTION_SHIFT_LATE_FAILURE';

// ShiftLateCancel
export const FETCH_TIME_DEDUCTION_SHIFT_LATE_CANCEL_REQUEST = 'FETCH_TIME_DEDUCTION_SHIFT_LATE_CANCEL_REQUEST';
export const FETCH_TIME_DEDUCTION_SHIFT_LATE_CANCEL_SUCCESS = 'FETCH_TIME_DEDUCTION_SHIFT_LATE_CANCEL_SUCCESS';
export const FETCH_TIME_DEDUCTION_SHIFT_LATE_CANCEL_FAILURE = 'FETCH_TIME_DEDUCTION_SHIFT_LATE_CANCEL_FAILURE';

export const SAVE_TIME_DEDUCTION_SHIFT_LATE_CANCEL_REQUEST = 'SAVE_TIME_DEDUCTION_SHIFT_LATE_CANCEL_REQUEST';
export const SAVE_TIME_DEDUCTION_SHIFT_LATE_CANCEL_SUCCESS = 'SAVE_TIME_DEDUCTION_SHIFT_LATE_CANCEL_SUCCESS';
export const SAVE_TIME_DEDUCTION_SHIFT_LATE_CANCEL_FAILURE = 'SAVE_TIME_DEDUCTION_SHIFT_LATE_CANCEL_FAILURE';

// ViewPunchOrders
export const FETCH_VIEW_PUNCH_ORDERS_REQUEST = 'FETCH_VIEW_PUNCH_ORDERS_REQUEST';
export const FETCH_VIEW_PUNCH_ORDERS_SUCCESS = 'FETCH_VIEW_PUNCH_ORDERS_SUCCESS';
export const FETCH_VIEW_PUNCH_ORDERS_FAILURE = 'FETCH_VIEW_PUNCH_ORDERS_FAILURE';

export const FETCH_SHIFT_LATE_APPROVAL_REQUEST = 'FETCH_SHIFT_LATE_APPROVAL_REQUEST';
export const FETCH_SHIFT_LATE_APPROVAL_SUCCESS = 'FETCH_SHIFT_LATE_APPROVAL_SUCCESS';
export const FETCH_SHIFT_LATE_APPROVAL_FAILURE = 'FETCH_SHIFT_LATE_APPROVAL_FAILURE';

export const SAVE_SHIFT_LATE_APPROVAL_REQUEST = 'SAVE_SHIFT_LATE_APPROVAL_REQUEST';
export const SAVE_SHIFT_LATE_APPROVAL_SUCCESS = 'SAVE_SHIFT_LATE_APPROVAL_SUCCESS';
export const SAVE_SHIFT_LATE_APPROVAL_FAILURE = 'SAVE_SHIFT_LATE_APPROVAL_FAILURE';

export const FETCH_LATE_REPORT_REQUEST = 'FETCH_LATE_REPORT_REQUEST';
export const FETCH_LATE_REPORT_SUCCESS = 'FETCH_LATE_REPORT_SUCCESS';
export const FETCH_LATE_REPORT_FAILURE = 'FETCH_LATE_REPORT_FAILURE';

export const FETCH_LATE_CONSOLIDATED_REPORT_REQUEST = 'FETCH_LATE_CONSOLIDATED_REPORT_REQUEST';
export const FETCH_LATE_CONSOLIDATED_REPORT_SUCCESS = 'FETCH_LATE_CONSOLIDATED_REPORT_SUCCESS';
export const FETCH_LATE_CONSOLIDATED_REPORT_FAILURE = 'FETCH_LATE_CONSOLIDATED_REPORT_FAILURE';

export const FETCH_SHIFT_LATE_APPROVAL_EMPLOYEE_REQUEST = 'FETCH_SHIFT_LATE_APPROVAL_EMPLOYEE_REQUEST';
export const FETCH_SHIFT_LATE_APPROVAL_EMPLOYEE_SUCCESS = 'FETCH_SHIFT_LATE_APPROVAL_EMPLOYEE_SUCCESS';
export const FETCH_SHIFT_LATE_APPROVAL_EMPLOYEE_FAILURE = 'FETCH_SHIFT_LATE_APPROVAL_EMPLOYEE_FAILURE';

export const FETCH_SHIFT_LATE_CANCEL_EMPLOYEE_REQUEST = 'FETCH_SHIFT_LATE_CANCEL_EMPLOYEE_REQUEST';
export const FETCH_SHIFT_LATE_CANCEL_EMPLOYEE_SUCCESS = 'FETCH_SHIFT_LATE_CANCEL_EMPLOYEE_SUCCESS';
export const FETCH_SHIFT_LATE_CANCEL_EMPLOYEE_FAILURE = 'FETCH_SHIFT_LATE_CANCEL_EMPLOYEE_FAILURE';

export const RESET_TIME_DEDUCTION_SHIFT_LATE_CANCEL = 'RESET_TIME_DEDUCTION_SHIFT_LATE_CANCEL';